export default __webpack_public_path__ + "static/media/logo_short_edge.f8f15331.png";